import React from 'react';
import './ui.css';

export const Card: React.FC<{
  title?: React.ReactNode; actions?: React.ReactNode;
  children: React.ReactNode; className?: string;
}> = ({ title, actions, children, className = '' }) => (
  <div className={`ui-card ${className}`.trim()}>
    {(title || actions) && (
      <div className="ui-card__header">
        <h3 className="ui-card__title">{title}</h3>
        {actions && <div>{actions}</div>}
      </div>
    )}
    <div className="ui-card__body">{children}</div>
  </div>
);
